import React from 'react';
import {
	Image, StyleSheet, Text, View,
} from '@react-pdf/renderer';
import { sharedStyles } from 'Views/Pages/Pdf/styles';
import moment from 'moment/moment';
import { StudyPlanEntity, UserEntity } from 'Models/Entities';
import { INSTITUTION_IMAGES } from 'Constants';

interface HeaderProps {
	documentName: string;
	studyPlan: StudyPlanEntity,
}

const styles = StyleSheet.create({
	planDetails: {
		alignSelf: 'center',
		display: 'flex',
		gap: 2,
		flexDirection: 'column',
		justifyContent: 'flex-end',
		alignItems: 'flex-end',
	},
	planName: {
		fontSize: 12,
		textAlign: 'right',
		maxWidth: 300,
	},
	programTitle: {
		textAlign: 'right',
		maxWidth: 300,
	},
	planTags: {
		color: '#757575',
		fontSize: 10,
		display: 'flex',
		flexDirection: 'row',
		gap: 4,
		alignItems: 'center',
	},
	institutionName: {
		position: 'absolute',
		top: 24,
		right: 24,
	},
	userName: {
		fontSize: 10,
		fontWeight: 'bold',
		textTransform: 'uppercase',
	},
});

const Header = (props: HeaderProps) => {
	const {
		documentName,
		studyPlan,
	} = props;

	const getUserNameAndId = () => {
		const user = studyPlan.getAssignedUser();
		const studentId = user instanceof UserEntity ? (user.studentId || '') : '';
		return `${studentId} ${user.getDisplayName()}`;
	};

	return (
		<>
			<Text
				style={[sharedStyles.documentName, sharedStyles.darkGrey]}
				fixed
			>
				{documentName} - {moment(new Date()).format('DD/MM/YYYY HH:mm:ss A')}
			</Text>
			<Text
				style={[styles.institutionName, sharedStyles.darkGrey]}
				fixed
			>
				{studyPlan.campus.institution.name}
			</Text>
			<View style={sharedStyles.planHeader} fixed>
				<View>
					<Image
						src={INSTITUTION_IMAGES.LOGO}
						style={{ height: 60 }}
					/>
				</View>
				<View style={styles.planDetails}>
					<Text style={styles.userName}>{getUserNameAndId()}</Text>
					<Text style={styles.planName}>{studyPlan.getDisplayName()}</Text>
					<Text style={[styles.programTitle, sharedStyles.darkGrey]}>
						{studyPlan.programVersion.program.getDisplayName()}
					</Text>
					<View style={styles.planTags}>
						<Text>{studyPlan.programVersion.program.code}</Text>
						<View style={sharedStyles.littleDot} />
						<Text>{studyPlan.programVersion.getDisplayName()}</Text>
						<View style={sharedStyles.littleDot} />
						<Text>{studyPlan.campus.getDisplayName()}</Text>
					</View>
				</View>
			</View>
		</>
	);
};

export default Header;
